import { env } from './env';

const AUTH_TOKEN_KEY = 'vishwajyot_auth_token';

export class ApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
  }
}

export const getAuthToken = (): string | null => {
  if (typeof window === 'undefined') return null;
  return window.sessionStorage.getItem(AUTH_TOKEN_KEY);
};

export const setAuthToken = (token: string | null): void => {
  if (typeof window === 'undefined') return;
  if (!token) {
    window.sessionStorage.removeItem(AUTH_TOKEN_KEY);
    return;
  }
  window.sessionStorage.setItem(AUTH_TOKEN_KEY, token);
};

export async function apiFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  if (!env.apiBaseUrl) {
    throw new ApiError('Backend API URL is not configured.', 0);
  }

  const token = getAuthToken();
  const headers = new Headers(init.headers);
  headers.set('Content-Type', 'application/json');
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  const response = await fetch(`${env.apiBaseUrl}${path}`, {
    ...init,
    headers,
  });

  const text = await response.text();
  let payload: { error?: string } | T = {} as T;

  if (text) {
    try {
      payload = JSON.parse(text) as { error?: string } | T;
    } catch {
      throw new ApiError(text || 'Unexpected server response', response.status);
    }
  }

  if (!response.ok) {
    const message =
      typeof payload === 'object' &&
      payload &&
      'error' in payload &&
      typeof payload.error === 'string'
        ? payload.error
        : `Request failed (${response.status})`;
    throw new ApiError(message, response.status);
  }

  return payload as T;
}
